'use client';

import type { PropsWithChildren } from 'react';
import useAsync from 'react-use/lib/useAsync';

import { initAuth } from '../store.tsx';

export const AuthProvider = ({
  children,
  isAuthCompassion = false,
}: PropsWithChildren & { isAuthCompassion?: boolean }) => {
  /**
   * Initialize state once mounted.
   * TODO: look into if this would be a good candidate for useTransition
   */
  useAsync(async () => {
    await initAuth(isAuthCompassion);
  }, []);

  // Removing the fragment causes a break
  return <>{children}</>;
};
